import { palette } from './palette';

export const color = {
  primary: palette.red,
  primary300: palette.red300,
  primary500: palette.red500,
  primary700: palette.red700,
  secondary: palette.gray600,
  navbar: palette.black,
  success: palette.green,
  info: palette.cyan,
  warning: palette.yellow,
  danger: palette.red,
  light: palette.gray100,
  dark: palette.gray800,
  bodyColor: palette.gray800,
};

export const visionColor = {
  primary: palette.blue,
  primary300: palette.blue300,
  primary500: palette.blue500,
  primary700: palette.blue700,
  secondary: palette.gray600,
  navbar: palette.blue,
  success: palette.green,
  info: palette.cyan,
  warning: palette.yellow,
  danger: palette.red,
  light: palette.gray100,
  dark: palette.gray800,
  bodyColor: palette.gray800,
};
